import { render, staticRenderFns } from "./ProductVideo.vue?vue&type=template&id=b210cef4&scoped=true&"
import script from "./ProductVideo.vue?vue&type=script&lang=js&"
export * from "./ProductVideo.vue?vue&type=script&lang=js&"
import style0 from "./ProductVideo.vue?vue&type=style&index=0&id=b210cef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b210cef4",
  null
  
)

export default component.exports